module.exports = __webpack_public_path__ + "img/quaro_final_rgb.32b0243a.svg";